import OrderModel from '@/common/models/order-model';
import CouponModel from '@/common/models/coupon-model';
import InvoiceModel from '@/common/models/invoice-model';
import TransactionModel from '@/common/models/transaction-model';

const BADGES_COLOR_MAP = {
    type: {
        refund: 'warning',
        void: 'warning',
    },
    status: {
        completed: 'positive',
        active: 'positive',
        pending: 'warning',
        'pending-confirmation': 'warning',
        inactive: 'negative',
    },
    cardStatus: {
        active: 'positive',
        inactive: 'warning',
        deactivated: 'negative',
    },
    creditMemoStatus: {
        'refund-due': '',
        refunded: 'positive',
        'refund-failed': 'negative',
        'not-applied': '',
        'partially-applied': 'info',
        applied: 'positive',
        voided: '',
    },
    creditMemoType: {
        adjustment: 'info',
        refundable: 'warning',
    },
    result: {
        approved: 'positive',
        canceled: 'negative',
        declined: 'negative',
    },
    method: {
        GET: 'positive',
        POST: 'info',
        PUT: 'warning',
        DELETE: 'negative',
    },
    orderStatus: {
        [OrderModel.Statuses.active]: 'positive',
        [OrderModel.Statuses.churned]: 'negative',
        [OrderModel.Statuses.canceled]: 'warning',
        [OrderModel.Statuses.paused]: 'info',
        [OrderModel.Statuses.pending]: 'info',
        [OrderModel.Statuses.suspended]: 'info',
    },
    orderBillingStatus: {
        [OrderModel.BillingStatuses.unpaid]: 'warning',
        [OrderModel.BillingStatuses.pastDue]: 'warning',
        [OrderModel.BillingStatuses.delinquent]: 'warning',
        [OrderModel.BillingStatuses.paid]: 'positive',
        [OrderModel.BillingStatuses.voided]: 'info',
        [OrderModel.BillingStatuses.refunded]: 'info',
        [OrderModel.BillingStatuses.disputed]: 'warning',
        [OrderModel.BillingStatuses.abandoned]: 'warning',
    },
    couponStatus: {
        [CouponModel.CouponStatus.draft]: 'warning',
        [CouponModel.CouponStatus.issued]: 'positive',
        [CouponModel.CouponStatus.expired]: 'negative',
    },
    orderType: {
        [OrderModel.Types.oneTime]: 'info',
        [OrderModel.Types.subscription]: '',
    },
    invoiceStatus: {
        [InvoiceModel.Status.draft]: 'info',
        [InvoiceModel.Status.upcoming]: 'info',
        [InvoiceModel.Status.issued]: 'info',
        [InvoiceModel.Status.pastDue]: 'negative',
        [InvoiceModel.Status.unpaid]: 'info',
        [InvoiceModel.Status.paid]: 'positive',
        [InvoiceModel.Status.abandoned]: '',
        [InvoiceModel.Status.voided]: '',
        [InvoiceModel.Status.refunded]: '',
        [InvoiceModel.Status.disputed]: '',
        [InvoiceModel.Status.delinquent]: '',
    },
    transactionType: {
        [TransactionModel.Types.authorize]: 'positive',
        [TransactionModel.Types.capture]: 'info',
        [TransactionModel.Types.credit]: 'warning',
        [TransactionModel.Types.refund]: 'negative',
        [TransactionModel.Types.sale]: '',
        [TransactionModel.Types.void]: '',
    },
    transactionStatus: {
        [TransactionModel.Statuses.completed]: 'positive',
        [TransactionModel.Statuses.connectionError]: 'negative',
        [TransactionModel.Statuses.neverSent]: '',
        [TransactionModel.Statuses.pending]: 'warning',
        [TransactionModel.Statuses.sending]: 'info',
        [TransactionModel.Statuses.suspended]: '',
        [TransactionModel.Statuses.refunded]: 'warning',
        [TransactionModel.Statuses.partiallyRefunded]: 'warning',
        [TransactionModel.Statuses.timeout]: 'negative',
        [TransactionModel.Statuses.waitingCapture]: 'warning',
        [TransactionModel.Statuses.waitingRefund]: 'warning',
    },
    transactionResult: {
        [TransactionModel.Results.abandoned]: '',
        [TransactionModel.Results.approved]: 'positive',
        [TransactionModel.Results.canceled]: 'negative',
        [TransactionModel.Results.declined]: 'negative',
        [TransactionModel.Results.unknown]: '',
    },
};

export function getBadgeType(resource, status) {
    return BADGES_COLOR_MAP[resource][status] || '';
}

export default BADGES_COLOR_MAP;
